import { atom, selector } from 'recoil'
import Decimal from 'decimal.js'
import { marketSymbolState } from '@/recoil/Market'
import { positionMapValue } from '@/recoil/Position'
import { ORDER_SIDE } from '@/constants/order'

export const allOpenOrderListState = atom({
  key: 'AllOpenOrderList',
  default: []
})

export const filledOrderListState = atom({
  key: 'FilledOrderList',
  default: []
})

export const openOrderListValue = selector({
  key: 'OpenOrderList',
  get: ({ get }) => {
    const marketSymbol = get(marketSymbolState)
    return get(allOpenOrderListState).filter(
      ({ symbol }) => symbol === marketSymbol
    )
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const reduceOrderMapValue = selector({
  key: 'ReduceOrderMap',
  get: ({ get }) => {
    const allOpenOrderList = get(allOpenOrderListState)
    const positionMap = get(positionMapValue)
    const map = {}
    allOpenOrderList.forEach(({ symbol, side, quantity, executed }) => {
      const position = positionMap[symbol]
      if (position && !Decimal(position.position_qty).eq(0)) {
        const isLongPosition = Decimal(position.position_qty).gt(0)
        const isReverseSideOrder =
          (isLongPosition && side === ORDER_SIDE.sell) ||
          (!isLongPosition && side === ORDER_SIDE.buy)
        if (isReverseSideOrder) {
          const { size = 0, total = 0 } = map[symbol] || {}
          map[symbol] = {
            size: Decimal(size).add(Decimal(quantity).sub(executed)).toNumber(),
            total: Decimal(total).add(1).toNumber()
          }
        }
      }
    })
    return map
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})
